// extracted by mini-css-extract-plugin
module.exports = {"integrationsContainer":"_6bd157","integration":"_57de98","link":"_6b4908","description":"_5212d6","divider":"_3f4adb"};